import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const CallToSubscribeSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div className="bg-[rgba(54,54,58,0.3)]">
            <div className="relative flex flex-col items-center mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] py-[100px] dmax2:py-[60px]">
                <h1 className="H24B dmax2:H20B text-textWhite text-center w-full">{t("main.callToSubscribeTitle")}</h1>
                <span className="H20 dmax2:H14 text-textFaded text-center max-w-[844px]">
                    {t("main.callToSubscribeText")}
                </span>
                <div className="relative">
                    <Link
                        to="/subscription"
                        className="button H16B dmax2:H14B text-textWhite h-[50px] dmax2:h-10 px-6 dmax2:px-4 mt-10 transition duration-300"
                    >
                        {t("main.callToSubscribeButton")}
                    </Link>
                    <div className="absolute top-[45px] dmax2:top-[30px] right-[-75px] dmax2:right-[-65px] flex justify-center items-center H12 text-textWhite bg-accentGreen rounded-[30px] rotate-[30deg] dmax2:rotate-[21deg] h-7 dmax2:h-[26px] px-4 dmax2:px-3">
                        {t("main.callToSubscribeLabel")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CallToSubscribeSection;
